// 共通機能を管理するモジュール
const CommonModule = {
    // 初期化関数
    init() {
        this.setupHamburgerMenu();
        this.setupScrollAnimations();
        this.addInClassOnLoad(); // ページ読み込み時のクラス付与関数を実行
    },

    // ページ読み込み時に特定の要素へ .in クラスを付与
    addInClassOnLoad() {
        const selectors = [
            '#main article#event .contents.contents1 h2',
            '#main article#event .contents.contents1 .img',
            '#main article#event .contents.contents1 .text',
            '#main article#event .contents.contents1 .block-wrap'
        ];

        // 該当する全要素を取得して .in を追加
        document.querySelectorAll(selectors.join(',')).forEach((element) => {
            element.classList.add('in');
        });
    },

    // ハンバーガーメニューの設定
    setupHamburgerMenu() {
        const hamburger = document.querySelector('.hamburger');
        const body = document.querySelector('body');

        hamburger?.addEventListener('click', () => {
            body?.classList.toggle('nav-open');
        });
    },

    // スクロールアニメーションの設定
    setupScrollAnimations() {
        // 既存のScrollTriggerインスタンスをクリア
        ScrollTrigger.getAll().forEach(trigger => trigger.kill());

        gsap.utils.toArray('.framein').forEach((framein: any) => {
            // 既存の.inクラスを削除
            framein.classList.remove('in');

            ScrollTrigger.create({
                trigger: framein,
                start: "top 80%",
                toggleClass: "in",
                once: true, // トリガー発火後にインスタンスを破棄し、クラスが付与された状態を維持
                markers: false
            });
        });
    },
};

// DOMContentLoadedイベントで初期化
document.addEventListener('DOMContentLoaded', () => {
    CommonModule.init();
});

/*////////////////////////////////////////////////////////
スムーススクロール
////////////////////////////////////////////////////////*/
window.addEventListener("DOMContentLoaded", () => {
    const navLinks = document.querySelectorAll("nav ul li a");
    const body = document.querySelector('body');

    navLinks.forEach((navLink) => {
        const href = navLink.getAttribute("href");
        if (href && href.startsWith("#")) {
            navLink.addEventListener("click", (e) => {
                e.preventDefault();

                // bodyから.nav-openクラスを削除（ハンバーガーメニューを閉じる）
                if (body) {
                    body.classList.remove('nav-open');
                }

                const targetElement = document.querySelector(href);
                if (targetElement) {
                    const offset = 0;
                    const targetElementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;

                    window.scrollTo({
                        top: targetElementPosition - offset,
                        behavior: 'smooth'
                    });
                }
            });
        }
    });
});